import React from 'react';
import PropTypes from 'prop-types';

export const CommentIcon = ({ style, color }) => {
   return (
      <svg width='40px' height='40px' style={ style } viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='9.-Students-Room' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Artboard'>
               <g id='Icon-/--Comment'>
                  <polygon id='Path' points='0 0 40 0 40 40 0 40' />
                  <polygon id='Path' points='0 0 40 0 40 40 0 40' />
                  <circle id='Oval' fillOpacity='0.1' fill={ color } fillRule='evenodd' cx='20' cy='20' r='20' />
                  <path
                     d='M27.5,11.6666667 L12.5,11.6666667 C11.1210938,11.6666667 10,12.7876949 10,14.1665205 L10,25.4158629 C10,26.7946886 11.1210938,27.9157168 12.5,27.9157168 L16.25,27.9157168 L16.25,31.196775 C16.25,31.5795651 16.6875,31.8022084 16.9960938,31.5756591 L21.875,27.9157168 L27.5,27.9157168 C28.8789063,27.9157168 30,26.7946886 30,25.4158629 L30,14.1665205 C30,12.7876949 28.8789063,11.6666667 27.5,11.6666667 Z'
                     id='Path'
                     fill={ color }
                     fillRule='evenodd'
                  />
               </g>
            </g>
         </g>
      </svg>
   );
};

export const ReplyIcon = ({ style, color }) => {
   return (
      <svg width='20px' height='20px' style={ style } viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='9.-Students-Room' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Artboard'>
               <g id='Icon-/--Comment'>
                  <path
                     d='M16.547619,1.66666667 C17.5334821,1.66666667 18.3333333,2.46651786 18.3333333,3.45238095 L18.3333333,16.547619 C18.3333333,17.5334821 17.5334821,18.3333333 16.547619,18.3333333 L3.45238095,18.3333333 C2.46651786,18.3333333 1.66666667,17.5334821 1.66666667,16.547619 L1.66666667,3.45238095 C1.66666667,2.46651786 2.46651786,1.66666667 3.45238095,1.66666667 L16.547619,1.66666667 Z M13.75,5.83333333 L6.25,5.83333333 C5.56054688,5.83333333 5,6.39384744 5,7.08326027 L5,12.7079315 C5,13.3973443 5.56054688,13.9578584 6.25,13.9578584 L8.125,13.9578584 L8.125,15.5983875 C8.125,15.7897826 8.34375,15.9011042 8.49804688,15.7878296 L10.9375,13.9578584 L13.75,13.9578584 C14.4394531,13.9578584 15,13.3973443 15,12.7079315 L15,7.08326027 C15,6.39384744 14.4394531,5.83333333 13.75,5.83333333 Z'
                     id='Combined-Shape'
                     fill={ color }
                     fillRule='nonzero'
                  />
                  <polygon id='Path' points='0 0 20 0 20 20 0 20' />
                  <polygon id='Path' points='0 0 20 0 20 20 0 20' />
               </g>
            </g>
         </g>
      </svg>
   );
};

export const AchievementIcon = ({ style, color }) => {
   return (
      <svg width='40px' height='40px' style={ style } viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='9.-Students-Room' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Artboard' transform='translate(-24.000000, -56.000000)'>
               <g id='Card-/-Students-Room-/-Regular'>
                  <g id='Icon-/--Achievement' transform='translate(24.000000, 56.000000)'>
                     <polygon id='Path' points='0 0 40 0 40 40 0 40' />
                     <polygon id='Path' points='0 0 40 0 40 40 0 40' />
                     <circle id='Oval' fillOpacity='0.1' fill={ color } fillRule='evenodd' cx='20' cy='20' r='20' />
                     <path
                        d='M16.2937881,24.1652673 C15.9543385,23.8258209 16.1312898,23.9215221 15.3125482,23.7023859 C14.9410677,23.6027785 14.6145085,23.4113761 14.3191991,23.1820837 L12.5469517,27.5273097 C12.3754691,27.9480045 12.6957783,28.4050266 13.1496799,28.3878395 L15.2078618,28.3093254 L16.6234722,29.8046081 C16.935969,30.1342891 17.4844009,30.0315567 17.6558835,29.610862 L19.6890657,24.625805 C19.2656326,24.8617378 18.7957155,25.0000163 18.309783,25.0000163 C17.5480721,25.0000163 16.8324545,24.7035378 16.2937881,24.1652673 Z M27.4530483,27.5273097 L25.6808009,23.1820837 C25.3854915,23.4117667 25.0589323,23.6027785 24.6874518,23.7023859 C23.8644134,23.922694 24.0448803,23.8266022 23.7062119,24.1652673 C23.1675455,24.7035378 22.4515373,25.0000163 21.6898264,25.0000163 C21.2038939,25.0000163 20.7339768,24.8613472 20.3105437,24.625805 L22.3437259,29.610862 C22.5152085,30.0315567 23.064031,30.1342891 23.3761371,29.8046081 L24.7921382,28.3093254 L26.8503201,28.3878395 C27.3042217,28.4050266 27.6245309,27.9476139 27.4530483,27.5273097 L27.4530483,27.5273097 Z M22.773409,23.2813005 C23.3702778,22.6738907 23.4386365,22.7262334 24.2886277,22.4945974 C24.8312003,22.3465535 25.2554147,21.9149215 25.4007257,21.3625887 C25.6929102,20.2532358 25.6171297,20.3872175 26.4143871,19.5755149 C26.8116487,19.1712261 26.9667252,18.5817847 26.8214142,18.029452 C26.5296203,16.9208803 26.5292297,17.0755647 26.8214142,15.9658212 C26.9667252,15.4134884 26.8116487,14.824047 26.4143871,14.4197582 C25.6171297,13.6080556 25.6929102,13.7416467 25.4007257,12.6326844 C25.2554147,12.0803517 24.8312003,11.6487196 24.2886277,11.5006757 C23.1995765,11.203416 23.3308251,11.2811488 22.5327864,10.4690556 C22.1355249,10.0647668 21.556234,9.90656683 21.0136614,10.0546108 C19.9250008,10.3514798 20.0769523,10.3518705 18.9863386,10.0546108 C18.443766,9.90656683 17.8644751,10.0643762 17.4672136,10.4690556 C16.6699561,11.2807582 16.8012048,11.203416 15.7117629,11.5006757 C15.1691903,11.6487196 14.7449759,12.0803517 14.5996649,12.6326844 C14.3078711,13.7416467 14.3832609,13.6080556 13.5860035,14.4197582 C13.188742,14.824047 13.0332748,15.4134884 13.1789764,15.9658212 C13.4707703,17.0736116 13.4711609,16.9189272 13.1789764,18.0290613 C13.0336654,18.5813941 13.188742,19.1708355 13.5860035,19.5755149 C14.3832609,20.3872175 14.3074804,20.2532358 14.5996649,21.3625887 C14.7449759,21.9149215 15.1691903,22.3465535 15.7117629,22.4945974 C16.5859726,22.7328739 16.6512063,22.6953747 17.226591,23.2813005 C17.7433826,23.8074619 18.5484524,23.9016007 19.1695398,23.5086397 C19.6765398,23.1867733 20.3238508,23.1867733 20.8308508,23.5086397 C21.4515476,23.9016007 22.2566174,23.8074619 22.773409,23.2813005 Z M16.3148817,16.8736156 C16.3148817,14.8021725 17.9648647,13.122909 20,13.122909 C22.0351353,13.122909 23.6851183,14.8021725 23.6851183,16.8736156 C23.6851183,18.9450587 22.0351353,20.6243222 20,20.6243222 C17.9648647,20.6243222 16.3148817,18.9450587 16.3148817,16.8736156 L16.3148817,16.8736156 Z'
                        id='Shape'
                        fill={ color }
                        fillRule='evenodd'
                     />
                  </g>
               </g>
            </g>
         </g>
      </svg>
   );
};

export const ResourceIcon = ({ style, color }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'>
         <defs>
            <path id='a' d='M15.573 6.667l-7.813 7.76L0 6.667h4.427V0h6.667v6.667h4.479zM0 16.667h15.573v2.24H0v-2.24z' />
         </defs>
         <g fill='none' fillRule='evenodd' transform='translate(11.667 10)'>
            <mask id='b' fill='#fff'>
               <use xlinkHref='#a' />
            </mask>
            <use fill='#333' xlinkHref='#a' />
            <g fill='#FFF' fillRule='nonzero' mask='url(#b)'>
               <path
                  d='M-51.667-50h120V70h-120z'
                  id='Shape'
                  fill={ color }
                  fillRule='evenodd'
               />
            </g>
         </g>
      </svg>

   );
};

export const LikeIcon = ({ style, color }) => {
   return (
      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' style={ style }>
         <path fillRule='evenodd' clipRule='evenodd' d='M10.6739 1.50048C9.73209 1.48685 8.75224 1.76313 7.99897 2.54003C7.24001 1.76452 6.25025 1.50043 5.33334 1.50043C3.08453 1.50043 0.833344 3.36434 0.833344 6.00028C0.833344 8.54807 2.4635 10.6735 4.08329 12.1227C4.90216 12.8554 5.74206 13.437 6.42389 13.8374C6.76461 14.0375 7.07121 14.1955 7.32079 14.3053C7.44517 14.36 7.56126 14.4054 7.66412 14.438C7.75439 14.4667 7.87781 14.5 8.00001 14.5C8.12221 14.5 8.24563 14.4667 8.3359 14.438C8.43876 14.4054 8.55486 14.36 8.67924 14.3053C8.92881 14.1955 9.23541 14.0375 9.57613 13.8374C10.258 13.437 11.0979 12.8554 11.9167 12.1227C13.5365 10.6735 15.1667 8.54807 15.1667 6.00028C15.1667 3.35851 12.9106 1.53284 10.6739 1.50048Z' fill={ color } />
      </svg>

   // <svg width='20px' height='20px' style={ style } viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg'>
   //    <g id='9.-Students-Room' stroke='none' strokeWidth='1' fill={ color } fillRule='evenodd'>
   //       <g id='Artboard'>
   //          <g id='Icon-/--Like'>
   //             <polygon id='Path' points='0 0 20 0 20 20 0 20' />
   //             <polygon id='Path' points='0 0 20 0 20 20 0 20' />
   //             <path
   //                d='M16.547619,1.66666667 L3.45238095,1.66666667 C2.46651786,1.66666667 1.66666667,2.46651786 1.66666667,3.45238095 L1.66666667,16.547619 C1.66666667,17.5334821 2.46651786,18.3333333 3.45238095,18.3333333 L16.547619,18.3333333 C17.5334821,18.3333333 18.3333333,17.5334821 18.3333333,16.547619 L18.3333333,3.45238095 C18.3333333,2.46651786 17.5334821,1.66666667 16.547619,1.66666667 Z M14.594494,10.9040179 L10.4799107,15.1525298 C10.2157738,15.4278274 9.78422619,15.4278274 9.51636905,15.1525298 L5.40550595,10.9040179 C4.21130952,9.66889881 4.28199405,7.62276786 5.61755952,6.484375 C6.78199405,5.49107143 8.515625,5.66964286 9.58333333,6.77083333 L10.0037202,7.20238095 L10.4241071,6.77083333 C11.4918155,5.66964286 13.2254464,5.49107143 14.389881,6.484375 C15.7217262,7.62276786 15.7924107,9.66889881 14.594494,10.9040179 Z'
   //                id='Shape'
   //                fill={ backColor }
   //                fillRule='nonzero'
   //             />
   //          </g>
   //       </g>
   //    </g>
   // </svg>
   );
};

export const LikeNotFilledIcon = ({ color }) => {
   return (
      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path fillRule='evenodd' clipRule='evenodd' d='M10.6594 2.50037C9.78594 2.48773 8.96684 2.7849 8.41603 3.61108C8.3233 3.75017 8.16719 3.83372 8.00001 3.83372C7.83284 3.83372 7.67673 3.75018 7.58399 3.61108C7.03621 2.78945 6.20227 2.50043 5.33334 2.50043C3.58216 2.50043 1.83334 3.96974 1.83334 6.00028C1.83334 8.11903 3.20319 9.99347 4.75007 11.3775C5.51453 12.0614 6.29963 12.6047 6.9303 12.9751C7.24583 13.1604 7.51735 13.2993 7.72351 13.39C7.827 13.4355 7.90816 13.4663 7.96644 13.4848C7.98016 13.4892 7.99128 13.4924 8.00001 13.4948C8.00875 13.4924 8.01987 13.4892 8.03359 13.4848C8.09186 13.4663 8.17303 13.4355 8.27651 13.39C8.48267 13.2993 8.75419 13.1604 9.06973 12.9751C9.70039 12.6047 10.4855 12.0614 11.25 11.3775C12.7968 9.99347 14.1667 8.11902 14.1667 6.00028C14.1667 3.97557 12.4228 2.52589 10.6594 2.50037ZM7.99897 2.54003C8.75223 1.76313 9.73209 1.48685 10.6739 1.50048C12.9106 1.53284 15.1667 3.35851 15.1667 6.00028C15.1667 8.54807 13.5365 10.6735 11.9167 12.1227C11.0979 12.8554 10.258 13.437 9.57613 13.8374C9.23541 14.0375 8.92881 14.1955 8.67924 14.3053C8.55486 14.36 8.43876 14.4054 8.3359 14.438C8.24563 14.4667 8.12221 14.5 8.00001 14.5C7.87781 14.5 7.75439 14.4667 7.66412 14.438C7.56126 14.4054 7.44517 14.36 7.32079 14.3053C7.07121 14.1955 6.76461 14.0375 6.42389 13.8374C5.74206 13.437 4.90216 12.8554 4.08329 12.1227C2.4635 10.6735 0.833344 8.54807 0.833344 6.00028C0.833344 3.36434 3.08453 1.50043 5.33334 1.50043C6.25025 1.50043 7.24001 1.76452 7.99897 2.54003Z' fill={ color } />
      </svg>
   );
};


export const CheckIcon = ({ style, color }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd' transform='translate(2.667 2.667)'>
            <circle cx='13.333' cy='13.333' r='13.333' fill={ color } />
            <path
               fill='#FFF'
               fillRule='nonzero'
               d='M11.117 15.468L8.81 13.044c-.49-.515-1.283-.515-1.773 0-.494.519-.494 1.363 0 1.882l3.193 3.354c.49.515 1.283.515 1.773 0l7.627-8.012c.493-.519.493-1.363 0-1.882-.49-.515-1.283-.515-1.773 0l-6.74 7.082z'
            />
         </g>
      </svg>
   );
};
export const AudioStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L32 0 32 32 0 32z' opacity='.1' />
            <path fill={ color } d='M16 2.667c-6.627 0-12 5.373-12 12V24c0 2.213 1.787 4 4 4h4V17.333H6.667v-2.666c0-5.16 4.173-9.334 9.333-9.334s9.333 4.174 9.333 9.334v2.666H20V28h4c2.213 0 4-1.787 4-4v-9.333c0-6.627-5.373-12-12-12z' />
         </g>
      </svg>
   );
};
export const ImageStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path fill={ color } d='M28 25.333V6.667C28 5.2 26.8 4 25.333 4H6.667C5.2 4 4 5.2 4 6.667v18.666C4 26.8 5.2 28 6.667 28h18.666C26.8 28 28 26.8 28 25.333zM11.333 18l3.334 4.013L19.333 16l6 8H6.667l4.666-6z' />
            <path d='M0 0L32 0 32 32 0 32z' />
         </g>
      </svg>
   );
};
export const MultimediaStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path fill={ color } d='M24 5.333l2.667 4h-4l-2.667-4h-2.667l2.667 4h-4l-2.667-4h-2.666l2.666 4h-4l-2.666-4H5.333C3.867 5.333 2.68 6.533 2.68 8l-.013 16c0 1.467 1.2 2.667 2.666 2.667h21.334c1.466 0 2.666-1.2 2.666-2.667V5.333H24zm-9 15L13.333 24l-1.666-3.667L8 18.667 11.667 17l1.666-3.667L15 17l3.667 1.667L15 20.333zm7.587-4.413l-1.254 2.747-1.253-2.747-2.747-1.253 2.747-1.254 1.253-2.746 1.254 2.746 2.746 1.254-2.746 1.253z' />
            <path d='M0 0L32 0 32 32 0 32z' />
         </g>
      </svg>
   );
};
export const PdfStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L32 0 32 32 0 32z' transform='translate(-1.333)' />
            <path fill={ color } d='M26.333 4h-18c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3zm-12.75 11.25c0 1.245-1.005 2.25-2.25 2.25h-1.5v3h-2.25v-9h3.75c1.245 0 2.25 1.005 2.25 2.25v1.5zm7.5 3c0 1.245-1.005 2.25-2.25 2.25h-3.75v-9h3.75c1.245 0 2.25 1.005 2.25 2.25v4.5zm6-4.5h-2.25v1.5h2.25v2.25h-2.25v3h-2.25v-9h4.5v2.25zm-17.25 1.5h1.5v-1.5h-1.5v1.5zm7.5 3h1.5v-4.5h-1.5v4.5z' transform='translate(-1.333)' />
         </g>
      </svg>
   );
};
export const PowerPointStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L32 0 32 32 0 32z' />
            <path fill={ color } d='M28 4c1.48 0 2.667 1.187 2.667 2.667v18.666C30.667 26.813 29.48 28 28 28H4c-1.48 0-2.667-1.187-2.667-2.667V6.667C1.333 5.187 2.52 4 4 4zM14.667 20h-8v2.667h8V20zm6.266-8c-2.028.2-3.6 1.916-3.6 4s1.572 3.8 3.6 4zm4.4 4.404h-3.588V20c1.896-.188 3.4-1.7 3.588-3.596zm-10.666-1.737h-8v2.666h8v-2.666zM21.745 12v3.596h3.588c-.188-1.896-1.696-3.408-3.588-3.596zm-7.078-2.667h-8V12h8V9.333z' />
         </g>
      </svg>
   );
};
export const QuizStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path fill={ color } d='M17.333 12.667H24V10h-6.667v2.667zm0 9.333H24v-2.667h-6.667V22zm8 6H6.667C5.2 28 4 26.8 4 25.333V6.667C4 5.2 5.2 4 6.667 4h18.666C26.8 4 28 5.2 28 6.667v18.666C28 26.8 26.8 28 25.333 28zM8 14.667h6.667V8H8v6.667zm1.333-5.334h4v4h-4v-4zM8 24h6.667v-6.667H8V24zm1.333-5.333h4v4h-4v-4z' />
            <path d='M0 0H32V32H0z' />
         </g>
      </svg>
   );
};
export const TextStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L32 0 32 32 0 32z' />
            <path fill={ color } d='M25 4H7C5.35 4 4 5.35 4 7v18c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3zm-1.5 13.5h-15v-3h15v3zm-6 6h-9v-3h9v3zm6-12h-15v-3h15v3z' />
         </g>
      </svg>
   );
};
export const VideoStudentIcon = ({ style, color = '#7CB740' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L32 0 32 32 0 32z' />
            <path
               fill={ color }
               d='M16 5.333C10.112 5.333 5.333 10.112 5.333 16S10.112 26.667 16 26.667 26.667 21.888 26.667 16 21.888 5.333 16 5.333zM13.867 20.8v-9.6l6.4 4.8-6.4 4.8z'
            />
         </g>
      </svg>
   );
};


export const SliderLeftIcon = () => {
   return (
      <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path fillRule='evenodd' clipRule='evenodd' d='M12.0202 4.64645C12.2155 4.84171 12.2155 5.15829 12.0202 5.35355L9.28299 8.09081C8.88114 8.49266 8.60129 8.77306 8.40102 9.00897C8.20454 9.24041 8.1142 9.39592 8.06853 9.53647C7.97065 9.83774 7.97065 10.1623 8.06853 10.4635C8.1142 10.6041 8.20454 10.7596 8.40102 10.991C8.60128 11.2269 8.88113 11.5073 9.28298 11.9092L12.0202 14.6464C12.2155 14.8417 12.2155 15.1583 12.0202 15.3536C11.825 15.5488 11.5084 15.5488 11.3131 15.3536L8.57588 12.6163L8.56074 12.6012C8.17756 12.218 7.8685 11.9089 7.63868 11.6382C7.40204 11.3595 7.22018 11.0886 7.11748 10.7725C6.95433 10.2704 6.95433 9.72957 7.11748 9.22746C7.22018 8.91135 7.40204 8.64053 7.63868 8.36179C7.8685 8.09107 8.17756 7.78201 8.56074 7.39884L8.57588 7.3837L11.3131 4.64645C11.5084 4.45118 11.825 4.45118 12.0202 4.64645Z' fill='white' />
      </svg>
   );
};

export const CertificateIcon = ({ style, color = 'var(--textColor)' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
         <g fill='none' fillRule='evenodd'>
            <g>
               <g>
                  <g>
                     <g fill={ color }>
                        <path d='M6.617.294c.465-.391 1.141-.392 1.607-.002l1.401 1.174 1.827-.002h.002l.128.006c.55.057 1.004.47 1.102 1.026l.32 1.8 1.4 1.173c.466.39.584 1.055.28 1.582l-.911 1.583.319 1.8c.106.598-.232 1.184-.803 1.392l-1.586.58v7.662c0 .467-.257.891-.67 1.108-.414.216-.91.185-1.293-.08l-2.329-1.618-2.328 1.617c-.214.149-.463.224-.713.224-.198 0-.397-.047-.58-.143-.413-.217-.67-.64-.67-1.108l-.006-7.672-1.541-.56c-.571-.207-.91-.792-.805-1.39l.316-1.8-.915-1.582c-.305-.526-.188-1.192.277-1.583l1.399-1.176.316-1.8c.105-.598.622-1.033 1.23-1.034l1.827-.001zm.816 13.67l-1.716.626c-.142.052-.287.077-.43.077-.348 0-.684-.147-.922-.408l.005 5.809 2.685-1.864c.214-.149.499-.149.713 0l2.685 1.864v-5.763c-.336.33-.84.45-1.302.282l-1.718-.623zM7.421 1.25L6.023 2.426c-.225.19-.51.293-.804.294l-1.827.001-.316 1.8c-.05.29-.202.552-.427.741L1.251 6.438l.915 1.582c.147.254.2.553.149.842l-.316 1.8 1.718.623c.175.064.333.166.462.297l.018.02c.067.07.127.147.176.232l.915 1.582 1.717-.627c.275-.1.579-.1.855 0l1.717.623.913-1.583c.026-.047.057-.09.09-.133l.019-.025c.142-.177.33-.314.545-.393l1.717-.626-.32-1.8c-.05-.288.002-.587.149-.842l.912-1.583L12.2 5.253c-.225-.188-.377-.45-.428-.74l-.32-1.8-1.827.003c-.294 0-.579-.104-.804-.292l-1.4-1.173zm.005 2.636c1.987 0 3.604 1.617 3.604 3.604s-1.617 3.604-3.604 3.604-3.604-1.617-3.604-3.604 1.617-3.604 3.604-3.604zm0 1.25c-1.298 0-2.354 1.056-2.354 2.354s1.056 2.354 2.354 2.354S9.78 8.79 9.78 7.491 8.724 5.137 7.426 5.137z' transform='translate(-103 -266) translate(48 262) translate(55 4) translate(8 5.333)' />
                     </g>
                     <path d='M0 0H32V32H0z' transform='translate(-103 -266) translate(48 262) translate(55 4)' />
                  </g>
               </g>
            </g>
         </g>
      </svg>
   );
};

export const SliderRightIcon = () => {
   return (
      <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path fillRule='evenodd' clipRule='evenodd' d='M7.97994 4.64645C8.1752 4.45118 8.49179 4.45118 8.68705 4.64645L11.4243 7.38371L11.4394 7.39884C11.8226 7.78201 12.1317 8.09107 12.3615 8.36179C12.5981 8.64053 12.78 8.91135 12.8827 9.22746C13.0459 9.72957 13.0459 10.2704 12.8827 10.7725C12.78 11.0886 12.5981 11.3595 12.3615 11.6382C12.1317 11.9089 11.8226 12.218 11.4394 12.6012L11.4243 12.6163L8.68705 15.3536C8.49179 15.5488 8.1752 15.5488 7.97994 15.3536C7.78468 15.1583 7.78468 14.8417 7.97994 14.6464L10.7172 11.9092C11.1191 11.5073 11.3989 11.2269 11.5992 10.991C11.7956 10.7596 11.886 10.6041 11.9317 10.4635C12.0295 10.1623 12.0295 9.83774 11.9317 9.53647C11.886 9.39592 11.7956 9.24041 11.5992 9.00897C11.3989 8.77306 11.1191 8.49266 10.7172 8.09081L7.97994 5.35355C7.78468 5.15829 7.78468 4.84171 7.97994 4.64645Z' fill='white' />
      </svg>
   );
};

export const StudentRoomArrowIcon = ({ style, color = '#3F4F65' }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
         <g fill='none' fillRule='evenodd'>
            <g>
               <g>
                  <g>
                     <path d='M0 0H24V24H0z' transform='translate(-320 -341) translate(24 318) translate(296 23)' />
                     <path fill={ color } fillRule='nonzero' d='M9.868 5.5L8 7.489 12.237 12 8 16.511 9.868 18.5 16 12z' transform='translate(-320 -341) translate(24 318) translate(296 23) rotate(90 12 12)' />
                  </g>
               </g>
            </g>
         </g>
      </svg>
   );
};

export const SwipeRightIcon = ({ color }) => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'>
         <g fill='none' fillRule='evenodd'>
            <g>
               <g>
                  <path d='M0 0H48V48H0z' transform='translate(-1384 -964) matrix(0 1 1 0 1384 964)' />
                  <path fill={ color || '#333' } d='M10.586 16.586c.72-.721 1.855-.777 2.64-.167l.188.167L24 27.17l10.586-10.584c.72-.721 1.855-.777 2.64-.167l.188.167c.721.72.777 1.855.167 2.64l-.167.188-12 12c-.72.721-1.855.777-2.64.167l-.188-.167-12-12c-.781-.78-.781-2.047 0-2.828z' transform='translate(-1384 -964) matrix(0 1 1 0 1384 964)' />
               </g>
            </g>
         </g>
      </svg>
   );
};

export const SwipeLeftIcon = ({ color }) => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'>
         <g fill='none' fillRule='evenodd'>
            <g>
               <g>
                  <path d='M0 0H48V48H0z' transform='translate(-8 -964) rotate(90 -454 510)' />
                  <path fill={ color || '#333' } d='M10.586 16.586c.72-.721 1.855-.777 2.64-.167l.188.167L24 27.17l10.586-10.584c.72-.721 1.855-.777 2.64-.167l.188.167c.721.72.777 1.855.167 2.64l-.167.188-12 12c-.72.721-1.855.777-2.64.167l-.188-.167-12-12c-.781-.78-.781-2.047 0-2.828z' transform='translate(-8 -964) rotate(90 -454 510)' />
               </g>
            </g>
         </g>
      </svg>
   );
};

export const SearchMainhubIcon = () => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
         <g fill='none' fillRule='evenodd'>
            <g fill='#FFF' fillRule='nonzero'>
               <g>
                  <path d='M8.738 17.479c2.068 0 4.025-.717 5.593-2.028l.808.808-.268.268c-.141.141-.22.332-.22.53 0 .2.079.39.22.53l6.193 6.193c.146.146.338.22.53.22s.384-.074.53-.22l1.656-1.656c.141-.14.22-.331.22-.53s-.079-.39-.22-.53l-6.193-6.193c-.293-.293-.767-.293-1.06 0l-.327.327-.805-.805c1.345-1.578 2.083-3.557 2.083-5.653 0-2.334-.91-4.53-2.56-6.18C13.268.91 11.073 0 8.738 0 6.405 0 4.21.91 2.56 2.56.909 4.21 0 6.405 0 8.74c0 2.334.909 4.529 2.56 6.179 1.65 1.652 3.844 2.56 6.178 2.56zm13.45 4.116l-.595.594-5.132-5.132.595-.594 5.133 5.132zM3.62 3.62c1.367-1.367 3.184-2.12 5.118-2.12 1.933 0 3.751.753 5.119 2.12 1.367 1.368 2.12 3.186 2.12 5.12 0 1.933-.753 3.75-2.12 5.118-1.368 1.367-3.186 2.12-5.12 2.12-1.933 0-3.75-.753-5.117-2.12-1.368-1.367-2.12-3.185-2.12-5.118 0-1.935.752-3.752 2.12-5.12z' transform='translate(-1181 -40) translate(1181 40)' />
               </g>
            </g>
         </g>
      </svg>
   );
};

export const LockIcon = ({ color }) => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' version='1.1' id='Capa_1' x='0px' y='0px' width='24px' height='24px' viewBox='0 0 401.998 401.998' fill={ color || '#fff' }>
         <g>
            <path d='M357.45,190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218   C266.093,12.563,236.025,0,200.998,0c-35.026,0-65.1,12.563-90.222,37.688C85.65,62.814,73.091,92.884,73.091,127.907v54.821   h-9.135c-7.611,0-14.084,2.663-19.414,7.993c-5.33,5.326-7.994,11.799-7.994,19.417V374.59c0,7.611,2.665,14.086,7.994,19.417   c5.33,5.325,11.803,7.991,19.414,7.991H338.04c7.617,0,14.085-2.663,19.417-7.991c5.325-5.331,7.994-11.806,7.994-19.417V210.135   C365.455,202.523,362.782,196.051,357.45,190.721z M274.087,182.728H127.909v-54.821c0-20.175,7.139-37.402,21.414-51.675   c14.277-14.275,31.501-21.411,51.678-21.411c20.179,0,37.399,7.135,51.677,21.411c14.271,14.272,21.409,31.5,21.409,51.675V182.728   z' />
         </g>
      </svg>
   );
};

export const PasswordVisibleIcon = ({ className }) => {
   return (
      <svg className={ className } width='22' height='20' viewBox='0 0 22 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path fillRule='evenodd' clipRule='evenodd' d='M1.64645 0.646447C1.84171 0.451185 2.15829 0.451185 2.35355 0.646447L5.17933 3.47222L9.23219 7.52508L13.4748 11.7677L17.5278 15.8207L20.3536 18.6464C20.5488 18.8417 20.5488 19.1583 20.3536 19.3536C20.1583 19.5488 19.8417 19.5488 19.6464 19.3536L17.1101 16.8172C15.5286 17.8227 13.5019 18.5 11 18.5C7.35631 18.5 4.72853 17.0639 3.01484 15.2843C1.32103 13.5254 0.5 11.4066 0.5 10C0.5 8.34435 1.6408 5.67134 4.06192 3.76903L1.64645 1.35355C1.45118 1.15829 1.45118 0.841709 1.64645 0.646447ZM4.77463 4.48173C2.49513 6.22423 1.5 8.67327 1.5 10C1.5 11.0934 2.17897 12.9746 3.73516 14.5907C5.27147 16.1861 7.64369 17.5 11 17.5C13.2095 17.5 14.9891 16.9308 16.3837 16.0908L13.096 12.8031C12.5119 13.2405 11.7859 13.5 10.9999 13.5C9.06691 13.5 7.49991 11.933 7.49991 10C7.49991 9.21402 7.75942 8.48803 8.19679 7.9039L4.77463 4.48173ZM8.91409 8.62119C8.65213 9.01651 8.49991 9.49022 8.49991 10C8.49991 11.3807 9.6192 12.5 10.9999 12.5C11.5097 12.5 11.9834 12.3478 12.3787 12.0858L8.91409 8.62119ZM11 2.5C9.94443 2.5 8.98843 2.62992 8.12688 2.85611C7.96489 2.89864 7.80618 2.94459 7.65073 2.99374C7.38743 3.07698 7.1065 2.93102 7.02326 2.66772C6.94002 2.40443 7.08598 2.1235 7.34927 2.04026C7.52046 1.98613 7.69501 1.93561 7.87294 1.88889C8.82011 1.64022 9.8616 1.5 11 1.5C14.6437 1.5 17.2715 2.93608 18.9852 4.71568C20.679 6.47464 21.5 8.59336 21.5 10C21.5 11.029 21.0614 12.4244 20.1869 13.7722C20.0727 13.9482 19.9507 14.1239 19.8209 14.2984C19.6561 14.52 19.3429 14.566 19.1213 14.4012C18.8997 14.2364 18.8537 13.9232 19.0185 13.7016C19.1355 13.5443 19.2453 13.3861 19.348 13.2278C20.1488 11.9937 20.5 10.7852 20.5 10C20.5 8.90664 19.821 7.02536 18.2648 5.40932C16.7285 3.81392 14.3563 2.5 11 2.5Z' fill='#131F1E' />
      </svg>
   );
};
export const PasswordHiddenIcon = ({ className }) => {
   return (

      <svg className={ className } width='22' height='18' viewBox='0 0 22 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path fillRule='evenodd' clipRule='evenodd' d='M1.5 9C1.5 7.90664 2.17897 6.02536 3.73516 4.40932C5.27147 2.81392 7.64369 1.5 11 1.5C14.3563 1.5 16.7285 2.81392 18.2648 4.40932C19.821 6.02536 20.5 7.90664 20.5 9C20.5 10.0934 19.821 11.9746 18.2648 13.5907C16.7285 15.1861 14.3563 16.5 11 16.5C7.64369 16.5 5.27147 15.1861 3.73516 13.5907C2.17897 11.9746 1.5 10.0934 1.5 9ZM11 0.5C7.35631 0.5 4.72853 1.93608 3.01484 3.71568C1.32103 5.47464 0.5 7.59336 0.5 9C0.5 10.4066 1.32103 12.5254 3.01484 14.2843C4.72853 16.0639 7.35631 17.5 11 17.5C14.6437 17.5 17.2715 16.0639 18.9852 14.2843C20.679 12.5254 21.5 10.4066 21.5 9C21.5 7.59336 20.679 5.47464 18.9852 3.71568C17.2715 1.93608 14.6437 0.5 11 0.5ZM8.49991 9C8.49991 7.61929 9.6192 6.5 10.9999 6.5C12.3806 6.5 13.4999 7.61929 13.4999 9C13.4999 10.3807 12.3806 11.5 10.9999 11.5C9.6192 11.5 8.49991 10.3807 8.49991 9ZM10.9999 5.5C9.06691 5.5 7.49991 7.067 7.49991 9C7.49991 10.933 9.06691 12.5 10.9999 12.5C12.9329 12.5 14.4999 10.933 14.4999 9C14.4999 7.067 12.9329 5.5 10.9999 5.5Z' fill='#131F1E' />
      </svg>
   );
};


// Prop Types
PasswordVisibleIcon.propTypes = {
   className: PropTypes.string,
};
PasswordHiddenIcon.propTypes = {
   className: PropTypes.string,
};
LikeIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

ResourceIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

AchievementIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

CommentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

ReplyIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
CheckIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
VideoStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
TextStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
QuizStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
AudioStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
ImageStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
MultimediaStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
PdfStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
PowerPointStudentIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

SwipeRightIcon.propTypes = {
   color: PropTypes.string,
};

SwipeLeftIcon.propTypes = {
   color: PropTypes.string,
};
CertificateIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

StudentRoomArrowIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

// Default props

CommentIcon.defaultProps = {
   color: '#7CB740',
};
ReplyIcon.defaultProps = {
   color: '#C2CEDB',
};
AchievementIcon.defaultProps = {
   color: '#7CB740',
};
ResourceIcon.defaultProps = {
   color: '#7CB740',
};
LikeIcon.defaultProps = {
   color: '#ffffff',
};
CheckIcon.defaultProps = {
   color: '#7CB740',
};

LockIcon.propTypes = {
   color: PropTypes.string,
};

LikeNotFilledIcon.propTypes = {
   color: PropTypes.string,
};


LikeNotFilledIcon.defaultProps = {
   color: '#ffffff',
};
